<template>
  <div class='h-dialogContainer h-alarm-filter' >
    <form id='addRuleForm' >
      <div class='row h-row-inputBox' >
        <div class='col-sm-12 h-col-inputBox' style='padding-right: calc(50% + 50px);'>
          <div class='h-inputLit'>{{$t('Alarm.rulename')}}:</div>
          <ejs-textbox name='rulename' v-model='filterRule.filterName'  @keydown.native.enter.prevent="onEnterPressed"></ejs-textbox>
        </div>
        <div class='col-sm-6'>
          <div class='h-col-inputBox'>
            <div class='h-inputLit'>{{$t('Alarm.nodeSelect')}}:</div>
            <div class='h-borderBox h-filterTopoTree height-464'>
              <TopoTree ref='filterTopoTree' :searchBox='{ show: true }' :checkBox='{ show: true }' :hasBorder='true' graphType="0"  @keydown.native.enter.prevent="onEnterPressed"></TopoTree>
            </div>
          </div>
        </div>
        <div class='col-sm-6'>
          <div class='h-col-inputBox'>
            <div class='h-inputLit'>{{$t('Alarm.starttime')}}:</div>
            <ejs-datepicker name='starttime' format='yyyy-MM-dd' v-model='beginTime' :locale="locale"></ejs-datepicker>
          </div>
          <div class='h-col-inputBox'>
            <div class='h-inputLit'>{{$t('Alarm.endtime')}}:</div>
            <ejs-datepicker name='endtime' format='yyyy-MM-dd' v-model='endTime' :locale="locale"></ejs-datepicker>
          </div>
          <div class='h-col-inputBox'>
            <div class='h-inputLit'>{{$t('Pm.ne_type_id')}}</div>
            <ejs-multiselect v-model='neTypeSelectData' :dataSource='neTypeData' :fields='neTypeFields' mode='CheckBox' :enableSelectionOrder='false' :showSelectAll='false' :change='neTypeChange'></ejs-multiselect>
          </div>
          <div class='h-col-inputBox'>
            <div class='h-inputLit'>{{$t('Alarm.alarmLevel')}}</div>
            <div class='row' id='alarmLevelBox'>
              <div v-for='(alarm, index) in alarmLevelList' :key='index' class='col-sm-3 nopadding'>
                <ejs-checkbox ref='alarmLevelCheck' name='alarmLevel' :label='alarm.label' :value='alarm.value' :checked='alarm.checked' :change='levelChangeFunc'></ejs-checkbox>
              </div>
            </div>
          </div>
          <div class='h-col-inputBox'>
            <div class='h-inputLit'>{{$t('Alarm.alarmID')}}</div>
            <ejs-textbox name='alarmId' v-model='alarmID' :change='alarmIDChange' @keydown.native.enter.prevent="onEnterPressed"></ejs-textbox>
          </div>
          <div class='h-col-inputBox'>
            <div class='h-inputLit'>{{$t('Alarm.alarmName')}}</div>
            <ejs-textbox name='alarmName' v-model='alarmName' :change='alarmNameChange' @keydown.native.enter.prevent="onEnterPressed"></ejs-textbox>
          </div>
        </div>
      </div>
      <div class='row h-reset-margin'>
        <div id='alarmTree'>
          <div class='h-padding-25'>
            <div class='height-280'>
              <AlarmTable ref='alarmTable'></AlarmTable>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import { CheckBoxSelection } from '@syncfusion/ej2-vue-dropdowns';
import { FormValidator } from '@syncfusion/ej2-vue-inputs';
import AlarmTable from './AlarmTable';
import { EventBus } from '../../../plugins/eventBus';
import TopoTree from '../../topoconfig/TopoTree';

export default {
  name: 'addRule',
  components: {
    AlarmTable,
    TopoTree
  },
  data() {
    return {
      locale: localStorage.getItem('locale'),
      alarmLevelList: [
        { label: this.$t('Alarm.alarmLevel_0'), value: '0', checked: false },
        { label: this.$t('Alarm.alarmLevel_1'), value: '1', checked: false },
        { label: this.$t('Alarm.alarmLevel_2'), value: '2', checked: false },
        { label: this.$t('Alarm.alarmLevel_3'), value: '3', checked: false }
      ],
      alarmLevelArray: [],
      neTypeFields: { text: 'netype', value: 'netypeid' },
      neTypeData: [],
      neTypeSelectData: [],
      alarmID: '',
      alarmName: '',
      beginTime: new Date(),
      endTime: new Date(),
      filterRule: {
        filterName: '',
        beginTime: '',
        endTime: '',
        neIds: []
      },
      validationOption: {
        customPlacement(inputElement, errorElement) {
          errorElement.style.position = '';
          inputElement.parentElement.parentElement.appendChild(errorElement);
        },
        rules: {
          rulename: {
            required: [true, `${this.$t('Alarm.fieldIsRequired')}`],
            maxLength: [520, `${this.$t('Alarm.maxLength')}520`],
            regex: [/^[^'\\"<>%&\s]+$/, `${this.$t('Alarm.notInput')} ' " \\ < > &nbsp; % &  `]
          },
          starttime: {
            required: [true, `${this.$t('Alarm.startdatenull')}`],
            dateIso: [true, `${this.$t('Alarm.notValidDate')}`]
          },
          endtime: {
            required: [true, `${this.$t('Alarm.enddatenull')}`],
            dateIso: [true, `${this.$t('Alarm.notValidDate')}`]
          }
        }
      }
    };
  },
  provide: {
    multiselect: [CheckBoxSelection]
  },
  watch: {
    beginTime(val) {
      this.filterRule.beginTime = this.formatDataStr(val);
    },
    endTime(val) {
      this.filterRule.endTime = this.formatDataStr(val);
    }
  },
  methods: {
    onEnterPressed(event) {
      // 阻止自动触发提交
      event.stopPropagation();
    },
    formatDataStr(val) {
      const dateValue = new Date(val);
      let month = dateValue.getMonth() + 1;
      if (month < 10) {
        month = `0${month}`;
      }
      let day = dateValue.getDate();
      if (day < 10) {
        day = `0${day}`;
      }
      return `${dateValue.getFullYear()}-${month}-${day}`;
    },
    getArray(id) {
      const checkedDom = document.querySelectorAll(`#${id} [aria-checked=true] input`);
      const array = [];
      for (let i = 0; i < checkedDom.length; i++) {
        array.push(checkedDom[i].value);
      }
      return array;
    },
    neTypeChange() {
      this.$refs.alarmTable.queryConditions.neTypeList = this.neTypeSelectData;
      this.$refs.alarmTable.getAlarmTableData();
    },
    levelChangeFunc() {
      this.alarmLevelArray = this.getArray('alarmLevelBox');
      this.$refs.alarmTable.queryConditions.alarmLevelList = this.alarmLevelArray;
      this.$refs.alarmTable.getAlarmTableData();
    },
    alarmIDChange() {
      this.$refs.alarmTable.queryConditions.alarmID = this.alarmID;
      this.$refs.alarmTable.getAlarmTableData();
    },
    alarmNameChange() {
      this.$refs.alarmTable.queryConditions.alarmName = this.alarmName;
      this.$refs.alarmTable.getAlarmTableData();
    },
    setRuleId(ruleInfo) {
      // 获取指定规则ID，查询详情
      this.clearData();
      this.filterRule = {
        filterName: ruleInfo.filterName,
        beginTime: '',
        endTime: '',
        filterId: ruleInfo.filterId
      };
      this.beginTime = new Date(ruleInfo.beginTime);
      if (ruleInfo.endTime === 4102415999000) {
        ruleInfo.endTime = 4102329600000; // 如果是2099-12-31 23:59:59 默认设置成 2099-12-31 00:00:00 时间 来解决表单验证问题.
      }
      this.endTime = new Date(ruleInfo.endTime);
      const neIds = JSON.parse(ruleInfo.neIds);

      for (let i = 0; i < neIds.length; i++) {
        this.$refs.filterTopoTree.neIdListCache[neIds[i]] = true;
      }
      //刷新拓扑树
      this.$refs.filterTopoTree.refreshCheckStatus();
      for (let i = 0; i < ruleInfo.alarmNeTypeList.length; i++) {
        this.$refs.alarmTable.alarmListCache[ruleInfo.alarmNeTypeList[i].alarmId+'-'+ruleInfo.alarmNeTypeList[i].neTypeId] = true;
      }

    },
    clearData() {
      this.bindValidate();
      this.filterRule = {
        filterName: '',
        beginTime: '',
        endTime: ''
      };
      this.beginTime = new Date();
      this.endTime = new Date();
      this.$refs.alarmTable.clearCache();
      const errorDom = document.querySelectorAll('label.e-error');
      for (let i = 0; i < errorDom.length; i++) {
        errorDom[i].innerHTML = '';
      }
    },
    getNeTypeData() {
      let arr = [];
      // this.$axios.post('/lte/ems/topo/device/devType').then((response) => {
        this.$axios.post('/lte/ems/topo/ne/findNeTypeMain').then((response) => {
        if (response && response.status === 200) {
          arr = response.data.resultVal;
          this.neTypeData = arr.filter((x, index,self)=>{
              // 资源类型只显示enodeb类型
              if (x.netypeid == 10004) {
                var arrids = []
                arr.forEach((item,i) => {
                  arrids.push(item.netypeid)
                })
                return arrids.indexOf(x.netypeid) === index
              }
            })
        }
      });

    },
    getNeIds() {
      const neIdList = [];
      const nodeList = this.$refs.filterTopoTree.getNodeList();
      for (let i = 0; i < nodeList.length; i++) {
        neIdList.push(nodeList[i].id);
      }
      this.filterRule.neIds = neIdList;
    },
    getRuleData() {
      if (!this.validate()) {
        return false;
      }
      const alarmArray = this.$refs.alarmTable.getCheckedData();
      if (this.filterRule.beginTime === '') {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Alarm.startdatenull')});
        return false;
      }
      if (this.filterRule.endTime === '') {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Alarm.enddatenull')});
        return false;
      }
      if (new Date(this.filterRule.beginTime).getTime() > new Date(this.filterRule.endTime).getTime()) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Alarm.datevalidate')});
        return false;
      }
      if (alarmArray.length < 1) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Alarm.alarmnull')});
        return false;
      }
      this.getNeIds();
      return {
        alarmStaticInfo: alarmArray,
        filterRule: this.filterRule
      };
    },
    bindValidate() {
      this.formObj = new FormValidator('#addRuleForm', this.validationOption);
    },
    validate() {
      const formStatus = this.formObj.validate();
      return formStatus;
    }
  },
  beforeMount() {
    this.getNeTypeData();
  },
  mounted() {
    this.bindValidate();
  }
};
</script>
